"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDocument = getDocument;
exports.loadDocument = loadDocument;
exports.usePDFPage = usePDFPage;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _reactPdf = require("react-pdf");
var _pdfWorkerFactory = _interopRequireDefault(require("../../utils/pdf/pdf-worker-factory"));
_reactPdf.pdfjs.GlobalWorkerOptions.workerSrc = (0, _pdfWorkerFactory["default"])();

// One PDFDocumentProxy per URL, ref-counted by usePDFPage and loadDocument.
// When a URL's refs drop to zero the entry is removed and the pdfjs document
// is destroyed, freeing worker-side page/font/image data.
var documentCache = new Map();
function getOrCreateEntry(url) {
  var entry = documentCache.get(url);
  if (entry) return entry;
  var promise = _reactPdf.pdfjs.getDocument(url).promise;
  entry = {
    promise: promise,
    refCount: 0
  };
  documentCache.set(url, entry);
  promise["catch"](function () {
    if (documentCache.get(url) === entry) documentCache["delete"](url);
  });
  return entry;
}
function acquireDocument(url) {
  var entry = getOrCreateEntry(url);
  entry.refCount += 1;
  return entry.promise;
}
function releaseDocument(url) {
  var entry = documentCache.get(url);
  if (!entry) return;
  entry.refCount -= 1;
  if (entry.refCount > 0) return;
  documentCache["delete"](url);
  entry.promise.then(function (doc) {
    var _doc$destroy;
    return doc === null || doc === void 0 || (_doc$destroy = doc.destroy) === null || _doc$destroy === void 0 ? void 0 : _doc$destroy.call(doc);
  })["catch"](function () {});
}
function getDocument(url) {
  return getOrCreateEntry(url).promise;
}
function loadDocument(url, onSuccess, onError) {
  if (!url) {
    return function () {};
  }
  var cancelled = false;
  acquireDocument(url).then(function (doc) {
    if (!cancelled) {
      onSuccess === null || onSuccess === void 0 || onSuccess(doc);
    }
  })["catch"](function (err) {
    if (!cancelled) {
      onError === null || onError === void 0 || onError(err);
    }
  });
  return function () {
    cancelled = true;
    releaseDocument(url);
  };
}
function usePDFPage(url, pageNumber) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    maxWidth = _ref.maxWidth,
    maxHeight = _ref.maxHeight,
    onError = _ref.onError;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    imageUrl = _useState2[0],
    setImageUrl = _useState2[1];
  var _useState3 = (0, _react.useState)({
      width: maxWidth !== null && maxWidth !== void 0 ? maxWidth : 0,
      height: maxHeight !== null && maxHeight !== void 0 ? maxHeight : 0
    }),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    dimensions = _useState4[0],
    setDimensions = _useState4[1];
  var renderTaskRef = (0, _react.useRef)(null);
  var blobUrlRef = (0, _react.useRef)(null);
  var shouldAcquire = !!url && pageNumber > 0;
  (0, _react.useEffect)(function () {
    if (!shouldAcquire) return;
    acquireDocument(url);
    return function () {
      return releaseDocument(url);
    };
  }, [url, shouldAcquire]);
  (0, _react.useEffect)(function () {
    if (!url || !pageNumber || pageNumber <= 0) return;
    if (maxWidth === 0 || maxHeight === 0) return;
    var cancelled = false;
    function render() {
      return _render.apply(this, arguments);
    }
    function _render() {
      _render = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var doc, page, viewport, scaleX, scaleY, scale, scaledViewport, canvas, renderTask, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return getDocument(url);
            case 1:
              doc = _context.sent;
              if (!cancelled) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 3;
              return doc.getPage(pageNumber);
            case 3:
              page = _context.sent;
              if (!cancelled) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              viewport = page.getViewport({
                scale: 1
              });
              scaleX = maxWidth == null ? Infinity : maxWidth / viewport.width;
              scaleY = maxHeight == null ? Infinity : maxHeight / viewport.height;
              scale = Math.min(scaleX, scaleY);
              scaledViewport = page.getViewport({
                scale: Number.isFinite(scale) ? scale : 1
              });
              canvas = document.createElement('canvas');
              canvas.width = Math.round(scaledViewport.width);
              canvas.height = Math.round(scaledViewport.height);
              renderTask = page.render({
                canvasContext: canvas.getContext('2d'),
                viewport: scaledViewport
              });
              renderTaskRef.current = renderTask;
              _context.prev = 5;
              _context.next = 6;
              return renderTask.promise;
            case 6:
              _context.prev = 6;
              if (renderTaskRef.current === renderTask) {
                renderTaskRef.current = null;
              }
              return _context.finish(6);
            case 7:
              if (!cancelled) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return");
            case 8:
              canvas.toBlob(function (blob) {
                if (cancelled || !blob) return;
                if (blobUrlRef.current) URL.revokeObjectURL(blobUrlRef.current);
                var objectUrl = URL.createObjectURL(blob);
                blobUrlRef.current = objectUrl;
                setDimensions({
                  width: canvas.width,
                  height: canvas.height
                });
                setImageUrl(objectUrl);
              });
              _context.next = 11;
              break;
            case 9:
              _context.prev = 9;
              _t = _context["catch"](0);
              if (!((_t === null || _t === void 0 ? void 0 : _t.name) === 'RenderingCancelledException')) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return");
            case 10:
              onError === null || onError === void 0 || onError(_t);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 9], [5,, 6, 7]]);
      }));
      return _render.apply(this, arguments);
    }
    render();
    return function () {
      cancelled = true;
      if (renderTaskRef.current) {
        renderTaskRef.current.cancel();
        renderTaskRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, pageNumber, maxWidth, maxHeight]);
  (0, _react.useEffect)(function () {
    return function () {
      if (blobUrlRef.current) URL.revokeObjectURL(blobUrlRef.current);
    };
  }, []);
  return {
    imageUrl: imageUrl,
    dimensions: dimensions
  };
}